import { render, staticRenderFns } from "./ResearchUmapPlot.vue?vue&type=template&id=d37e6f48&scoped=true"
import script from "./ResearchUmapPlot.vue?vue&type=script&lang=js"
export * from "./ResearchUmapPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchUmapPlot.vue?vue&type=style&index=0&id=d37e6f48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e6f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d37e6f48')) {
      api.createRecord('d37e6f48', component.options)
    } else {
      api.reload('d37e6f48', component.options)
    }
    module.hot.accept("./ResearchUmapPlot.vue?vue&type=template&id=d37e6f48&scoped=true", function () {
      api.rerender('d37e6f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchUmapPlot.vue"
export default component.exports